"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DATA_GET_CART = exports.DATA_PRODUCT_MAX_QUANTITY = exports.SW_REDIRECT_DOMAIN_CHECKOUT = exports.SW_REDIRECT_DOMAIN_CART = exports.SW_COOKIE_NAME = exports.SW_COOKIE_CART_COUNT = exports.DATA_MODAL_BACKGROUND = exports.DATA_CLOSE = exports.DATA_SUCCESS_MESSAGE_MODAL = exports.DATA_CART_ITEMS = exports.DATA_PRODUCT_BUTTON = exports.DATA_PRODUCT_SELECT = exports.PRODUCT_SELECT_ID = exports.PRODUCT_GROUP_ID = exports.DATA_CART_COUNTER = exports.DATA_CART_EMPTY = exports.DATA_CART_FILLED = exports.DATA_TO_CHECKOUT = exports.DATA_TO_CART = exports.PRODUCTS_SECTION = exports.PRODUCT_CART_ITEMS = void 0;
exports.PRODUCT_CART_ITEMS = 'product_items';
exports.PRODUCTS_SECTION = 'data-products';
exports.DATA_TO_CART = 'data-to-cart';
exports.DATA_TO_CHECKOUT = 'data-to-checkout';
exports.DATA_CART_FILLED = 'data-cart-filled';
exports.DATA_CART_EMPTY = 'data-cart-empty';
exports.DATA_CART_COUNTER = 'data-cart-counter';
exports.PRODUCT_GROUP_ID = 'data-product-group-id';
exports.PRODUCT_SELECT_ID = 'data-product-select-id';
exports.DATA_PRODUCT_SELECT = 'data-product-select';
exports.DATA_PRODUCT_BUTTON = 'data-product-button';
exports.DATA_CART_ITEMS = 'data-cart-items';
exports.DATA_SUCCESS_MESSAGE_MODAL = 'data-success-message-modal';
exports.DATA_CLOSE = 'data-close-and-continue';
exports.DATA_MODAL_BACKGROUND = 'data-modal-background';
exports.SW_COOKIE_CART_COUNT = 'cart-count';
exports.SW_COOKIE_NAME = 'cart-token';
exports.SW_REDIRECT_DOMAIN_CART = '/shop/checkout/cart';
exports.SW_REDIRECT_DOMAIN_CHECKOUT = '/shop/checkout/confirm';
exports.DATA_PRODUCT_MAX_QUANTITY = 'data-product-max-quantity';
exports.DATA_GET_CART = 'data-ajax-get-cart';
